module.exports = __webpack_public_path__ + "img/PF-dev.c39655a0.png";